var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00977 20.5286H24.0591V21.5188H8.00977V20.5286Z",
    fill: "#001EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1094 4.2139H24.0606V5.20394H17.1094V4.2139Z",
    fill: "#001EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1094 8.29242H24.0606V9.2827H17.1094V8.29242Z",
    fill: "#001EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96482 9.87098H13.301C13.9138 9.87098 14.4118 9.37271 14.4118 8.76017V4.42352C14.4118 3.81075 13.9131 3.31223 13.301 3.31223L8.96482 3.31247C8.35204 3.31247 7.85352 3.81122 7.85352 4.42377V8.75998C7.85352 9.37276 8.35203 9.87098 8.96482 9.87098ZM8.84357 4.42352C8.84357 4.35723 8.89901 4.30203 8.96482 4.30203H13.301C13.3668 4.30203 13.4225 4.35747 13.4225 4.42352V8.75974C13.4225 8.82555 13.3668 8.88099 13.301 8.88099H8.96482C8.89901 8.88099 8.84357 8.82555 8.84357 8.75974V4.42352Z",
    fill: "#001EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0875 0.00024671H6.98321C5.38741 0.00024671 4.08906 1.29859 4.08906 2.89439V7.03819H2.53955C1.13901 7.03819 0 8.33629 0 9.93215V24.7207C0 26.3165 1.29835 27.6148 2.89414 27.6148H25.0874C26.6837 27.6148 27.9821 26.3165 27.9821 24.7207V2.89396C27.9816 1.29841 26.6832 0 25.0874 0L25.0875 0.00024671ZM26.9918 24.7212C26.9918 25.7711 26.1375 26.6256 25.0875 26.6256L2.8942 26.6254C1.84437 26.6254 0.989851 25.771 0.989851 24.721V9.93246C0.989851 8.88263 1.68485 8.02811 2.53936 8.02811H4.08888V21.0184C4.08888 21.2917 4.31066 21.5138 4.58377 21.5138C4.85714 21.5138 5.07867 21.2917 5.07867 21.0184L5.07891 2.89495C5.07891 1.84512 5.93324 0.990598 6.98326 0.990598H25.0876C26.1374 0.990598 26.9919 1.84493 26.9919 2.89495L26.9918 24.7212Z",
    fill: "#001EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00977 12.3716H24.0591V13.3618H8.00977V12.3716Z",
    fill: "#001EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00977 16.45H24.0591V17.4403H8.00977V16.45Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.178bd8ef513d4296484c43657dd2c594.svg";
export { ForwardRef as ReactComponent };